module.exports = "/_next/static/images/profile-cra-e7667192bf130021859b98e32be46ee0.png";